import {
  Stack,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import ClientIndustrial from "assets/client-industrial.png";
import Page from "components/Layout/Page/Page";
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { maskPhoneNumber, sanitizeEmail } from "utils/Masks/Masks";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PasswordCheckList from "components/Feedback/PasswordCheckList/PasswordCheckList";
import { useConsigazApi } from "hooks/useConsigazApi";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

export default function RegisterIndustrial() {
  const [showPassword, setShowPassword] = useState(false);
  const [selectValueDepartment, setSelectValueDepartment] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  const { state } = useLocation();

  const api = useConsigazApi();

  const handlePasswordFocus = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handlePasswordBlur = (e) => {
    formik.handleBlur(e);
    setAnchorEl(null);
  };

  const registerUser = async () => {
    if (selectValueDepartment === "") {
      return toast.error("Selecione um departamento");
    }

    const password = formik.values.password;

    if (!selectValueDepartment) {
      return toast.error("Selecione um departamento");
    }

    const cleanCpf = state.cpfAccess.replace(/\D/g, "");

    try {
      const response = await api.createUserIndustrial({
        type: "INDUSTRIAL",
        name: formik.values.name,
        phone: formik.values.phone,
        email: formik.values.email,
        password: password,
        department: selectValueDepartment,
        cpf: cleanCpf,
      });

      if (response.Erros && response.Erros.length) {
        return toast.error(response.Erros[0].Descricao);
      }

      const responseLink = await api.linkCNPJ({
        operacao: "AssociaCNPJ",
        cpf: cleanCpf,
        cnpj: state.cpfCnpj,
        clientCode: state.clientCode,
      });

      if (responseLink.Erros && responseLink.Erros.length) {
        return toast.error(responseLink.Erros[0].Descricao);
      }

      return router.push("/login");
    } catch (error) {
      console.error("Erro ao criar usuário:", error);
      return toast.error(error);
    }
  };

  const validationRegisterIndustrialSchema = Yup.object({
    name: Yup.string().required("Nome é obrigatório"),
    phone: Yup.string().required("Telefone é obrigatório"),
    email: Yup.string().email("Email inválido").required("Email é obrigatório"),
    confirmEmail: Yup.string()
      .required("Confirmação de email é obrigatória")
      .oneOf([Yup.ref("email")], "Os emails não coincidem"),
    password: Yup.string()
      .required("Senha obrigatória")
      .min(8, "A senha deve ter pelo menos 8 caracteres")
      .matches(/[A-Z]/, "Deve conter ao menos uma letra maiúscula")
      .matches(/\d/, "Deve conter ao menos um número")
      .matches(/[!@#$%^&*]/, "Deve conter ao menos um caractere especial"),
    confirmPassword: Yup.string()
      .required("Confirmação de senha é obrigatória")
      .oneOf([Yup.ref("password")], "As senhas não coincidem"),
  });

  const formik = useFormik({
    initialValues: {
      name: state?.nomeEmpresarial || state?.nomeFantasia || "",
      phone: "",
      email: "",
      confirmEmail: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: validationRegisterIndustrialSchema,
    onSubmit: () => {
      registerUser();
    },
  });

  const handleEmailChange = (field) => (e) => {
    formik.setFieldValue(field, sanitizeEmail(e.target.value));
  };

  const router = useHistory();

  return (
    <Page>
      <Stack
        justifyContent={"center"}
        alignItems="center"
        height="100vh"
        direction={"row"}
      >
        <IconButton
          sx={{
            position: "absolute",
            top: 50,
            left: 70,
          }}
          onClick={() => router.push("/login")}
        >
          <ArrowBackIcon
            sx={{
              color: "#fff",
              fontSize: "31px",
            }}
          />
        </IconButton>
        <Stack
          border={"1px solid #fff"}
          padding={"32px 24px"}
          borderRadius={"8px"}
          direction={"row"}
          width={"930px"}
          gap={"40px"}
          mb={12}
        >
          <Stack width={"80%"} mt={"20px"}>
            <TextField
              variant="standard"
              placeholder="Nome"
              color="secondary"
              fullWidth
              sx={{
                "& .MuiInputBase-input": {
                  color: "#2CABF9",
                },
                "& input::placeholder": {
                  color: "gray",
                },
              }}
              {...formik.getFieldProps("name")}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />

            <Stack direction={"row"} gap={"24px"} mt={"45px"}>
              <TextField
                variant="standard"
                placeholder="Telefone"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                {...formik.getFieldProps("phone")}
                onChange={(e) => {
                  const masked = maskPhoneNumber(e.target.value);
                  formik.setFieldValue("phone", masked);
                }}
                error={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
                fullWidth
              />
              <FormControl fullWidth variant="standard">
                <Select
                  displayEmpty
                  value={selectValueDepartment}
                  onChange={(e) => setSelectValueDepartment(e.target.value)}
                  sx={{
                    color: "#9e9e9e",
                  }}
                >
                  <MenuItem value="" disabled>
                    Departamento
                  </MenuItem>
                  <MenuItem value={"Faturamento"}>Faturamento</MenuItem>
                  <MenuItem value={"Financeiro"}>Financeiro</MenuItem>
                  <MenuItem value={"Logística"}>Logística</MenuItem>
                  <MenuItem value={"Compras"}>Compras</MenuItem>
                  <MenuItem value={"Proprietário"}>Proprietário</MenuItem>
                </Select>
              </FormControl>
            </Stack>
            <Stack direction={"row"} gap={"24px"} mt={"43px"}>
              <TextField
                variant="standard"
                placeholder="Email"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                {...formik.getFieldProps("email")}
                onChange={handleEmailChange("email")}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                fullWidth
              />
              <TextField
                variant="standard"
                placeholder="Confirmar email"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                }}
                {...formik.getFieldProps("confirmEmail")}
                onChange={handleEmailChange("confirmEmail")}
                error={
                  formik.touched.confirmEmail &&
                  Boolean(formik.errors.confirmEmail)
                }
                helperText={
                  formik.touched.confirmEmail && formik.errors.confirmEmail
                }
                fullWidth
              />
            </Stack>
            <Stack direction={"row"} gap={"20px"} mt={"40px"}>
              <TextField
                variant="standard"
                placeholder="Senha"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                  "& input": {
                    paddingLeft: "34px",
                  },
                }}
                type={showPassword ? "text" : "password"}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                          size="small"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
                {...formik.getFieldProps("password")}
                onFocus={handlePasswordFocus}
                onBlur={handlePasswordBlur}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
                fullWidth
              />
              <TextField
                variant="standard"
                placeholder="Confirmar senha"
                color="secondary"
                sx={{
                  "& .MuiInputBase-input": {
                    color: "#2CABF9",
                  },
                  "& input::placeholder": {
                    color: "gray",
                  },
                  "& input": {
                    paddingLeft: "34px",
                  },
                }}
                type={showPassword ? "text" : "password"}
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                          size="small"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
                {...formik.getFieldProps("confirmPassword")}
                error={
                  formik.touched.confirmPassword &&
                  Boolean(formik.errors.confirmPassword)
                }
                helperText={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                }
                fullWidth
              />
            </Stack>
            <Button
              variant="contained"
              color="secondary"
              sx={{
                color: "#fff",
                height: "45px",
                borderRadius: "36px",
                marginTop: "55px",
                p: "10px",
              }}
              fullWidth
              onClick={formik.handleSubmit}
            >
              Avançar
            </Button>
          </Stack>
          <Stack justifyContent={"center"} alignItems={"center"} width={"30%"}>
            <Typography fontSize={"24px"} fontWeight={700} color="#fff">
              Ainda não é cliente?
            </Typography>
            <Typography
              fontSize={"12px"}
              fontWeight={400}
              color="#fff"
              mb={"24px"}
              lineHeight={"100%"}
              mt={"8px"}
            >
              Informe, ao lado, seus dados a serem usados para solicitar
              serviços e abastecimentos.
            </Typography>
            <img
              src={ClientIndustrial}
              style={{
                height: "171px",
                width: "155px",
              }}
            />
          </Stack>
        </Stack>
      </Stack>
      <PasswordCheckList
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        value={formik.values.password}
      />
    </Page>
  );
}
